const fetchPageData = require("./fetchPageData");
const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

module.exports = async function fetchServerData(pageContext) {
	try {
		const { bundles, layouts, endpoint, config, configs } = pageContext;
		if (endpoint) {
			let fetchedData = await fetchPageData({
				endpoint,
				bundles,
				layouts,
				ssr: true,
				configs,
			});
			if (!fetchedData) {
				throw new Error("No data fetched");
			} else {
				return {
					status: 200,
					headers: {},
					props: {
						...fetchedData,
					},
				};
			}
		} else {
			return {
				status: 200,
				headers: {},
				props: {},
			};
		}
	} catch (error) {
		return {
			status: 500,
			headers: {},
			props: { error: error.message },
		};
	}
};
